var m = Object.defineProperty;
var T = (r, e, t) => e in r ? m(r, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[e] = t;
var a = (r, e, t) => T(r, typeof e != "symbol" ? e + "" : e, t);
import k from "isomorphic-unfetch";
import { parse as g, print as y } from "graphql";
import { jwtDecode as A } from "jwt-decode";
function N(r, e, t) {
  return r.document ? r : {
    document: r,
    variables: e,
    config: t
  };
}
function c(r) {
  var s;
  let e;
  const t = r.definitions.filter(
    (i) => i.kind === "OperationDefinition"
  );
  return t.length === 1 && (e = (s = t[0].name) == null ? void 0 : s.value), e;
}
function w(r) {
  if (typeof r == "string") {
    let t;
    try {
      const s = g(r);
      t = c(s);
    } catch {
    }
    return { query: r, operationName: t };
  }
  const e = c(r);
  return { query: y(r), operationName: e };
}
class S {
  constructor(e) {
    a(this, "_url");
    a(this, "accessToken");
    a(this, "adminSecret");
    a(this, "headers", {});
    a(this, "isAccessTokenValidOrNull", () => {
      if (!this.accessToken)
        return !0;
      try {
        const e = A(this.accessToken);
        return e.exp != null && e.exp * 1e3 > Date.now();
      } catch (e) {
        return console.error("Error decoding token:", e), !1;
      }
    });
    a(this, "awaitForValidAccessTokenOrNull", async () => {
      if (this.isAccessTokenValidOrNull())
        return !0;
      const e = () => this.isAccessTokenValidOrNull() ? Promise.resolve(!0) : new Promise((t) => {
        setTimeout(() => e().then(t), 100);
      });
      return e();
    });
    const { url: t, adminSecret: s } = e;
    this._url = t, this.accessToken = null, this.adminSecret = s;
  }
  async request(e, ...t) {
    const [s, i] = t, l = N(e, s, i), { headers: h, ...d } = i || {}, { query: p, operationName: f } = w(l.document);
    typeof process != "undefined" && !process.env.TEST_MODE && await this.awaitForValidAccessTokenOrNull();
    try {
      const o = await k(this.httpUrl, {
        method: "POST",
        body: JSON.stringify({
          operationName: f,
          query: p,
          variables: s
        }),
        headers: {
          "Content-Type": "application/json",
          ...this.generateAccessTokenHeaders(),
          ...this.headers,
          // graphql client headers to be sent with all `request` calls
          ...h
          // extra headers to be sent with a specific call
        },
        ...d
      });
      if (!o.ok)
        return {
          data: null,
          error: {
            error: o.statusText,
            message: o.statusText,
            status: o.status
          }
        };
      const { data: n, errors: u } = await o.json();
      return u ? {
        data: null,
        error: u
      } : typeof n != "object" || Array.isArray(n) || n === null ? {
        data: null,
        error: {
          error: "invalid-response",
          message: "incorrect response data from GraphQL server",
          status: 0
        }
      } : { data: n, error: null };
    } catch (o) {
      const n = o;
      return {
        data: null,
        error: {
          message: n.message,
          status: n.name === "AbortError" ? 0 : 500,
          error: n.name === "AbortError" ? "abort-error" : "unknown"
        }
      };
    }
  }
  /**
   * Use `nhost.graphql.httpUrl` to get the GraphQL HTTP URL.
   * @example
   * ```ts
   * const url = nhost.graphql.httpUrl;
   * ```
   *
   * @docs https://docs.nhost.io/reference/javascript/graphql/get-http-url
   */
  get httpUrl() {
    return this._url;
  }
  /**
   * Use `nhost.graphql.wsUrl` to get the GraphQL WebSocket URL.
   * @example
   * ```ts
   * const url = nhost.graphql.wsUrl;
   * ```
   *
   * @docs https://docs.nhost.io/reference/javascript/graphql/get-ws-url
   */
  get wsUrl() {
    return this._url.replace(/^(http)(s?):\/\//, "ws$2://");
  }
  /**
   * Use `nhost.graphql.url` to get the GraphQL URL.
   * @deprecated Use `nhost.graphql.httpUrl` and `nhost.graphql.wsUrl` instead.
   */
  get url() {
    return this._url;
  }
  /**
   * Use `nhost.graphql.getUrl()` to get the GraphQL URL.
   * @deprecated Use `nhost.graphql.httpUrl` and `nhost.graphql.wsUrl` instead.
   */
  getUrl() {
    return this._url;
  }
  /**
   * Use `nhost.graphql.setAccessToken` to a set an access token to be used in subsequent graphql requests. Note that if you're signin in users with `nhost.auth.signIn()` the access token will be set automatically.
   *
   * @example
   * ```ts
   * nhost.graphql.setAccessToken('some-access-token')
   * ```
   *
   * @docs https://docs.nhost.io/reference/javascript/graphql/set-access-token
   */
  setAccessToken(e) {
    if (!e) {
      this.accessToken = null;
      return;
    }
    this.accessToken = e;
  }
  /**
   * Use `nhost.graphql.getHeaders` to get the global headers sent with all graphql requests
   *
   * @example
   * ```ts
   * nhost.graphql.getHeaders()
   * ```
   *
   * @docs https://docs.nhost.io/reference/javascript/graphql/get-headers
   */
  getHeaders() {
    return this.headers;
  }
  /**
   * Use `nhost.graphql.setHeaders` to set global headers to be sent in all subsequent graphql requests
   *
   * @example
   * ```ts
   * nhost.graphql.setHeaders({
   *  'x-hasura-role': 'admin'
   * })
   * ```
   *
   * @docs https://docs.nhost.io/reference/javascript/graphql/set-headers
   */
  setHeaders(e) {
    e && (this.headers = {
      ...this.headers,
      ...e
    });
  }
  /**
   * Use `nhost.graphql.unsetHeaders` to remove global headers sent with all requests, except for the role header to preserve
   * the role set by 'setRole' method.
   *
   * @example
   * ```ts
   * nhost.graphql.unsetHeaders()
   * ```
   *
   * @docs https://docs.nhost.io/reference/javascript/graphql/unset-headers
   */
  unsetHeaders() {
    const e = this.headers["x-hasura-role"];
    this.headers = e ? { "x-hasura-role": e } : {};
  }
  generateAccessTokenHeaders() {
    return this.adminSecret ? {
      "x-hasura-admin-secret": this.adminSecret
    } : this.accessToken ? {
      Authorization: `Bearer ${this.accessToken}`
    } : {};
  }
}
export {
  S as NhostGraphqlClient
};
//# sourceMappingURL=index.esm.js.map
